import type { AddressObject, GeoLocationInput, InputMaybe } from "@/lib/gql/__generated__/graphql";

import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";
import { useFormAddressModel } from "@/components/features/items/edit/_shared/ui/components/main/questions/address/address/hooks/use-address";
import { useGeoLocation } from "@/components/features/items/edit/_shared/ui/components/main/questions/address/geo-location/hooks/use-get-location";

import type { HotelSettingsHotelInfoFormModelOnSetViewModelType } from "../..";
import type { HotelSettingsHotelInfoFormModel } from "../../../../type";

type Props = {
	viewModel: HotelSettingsHotelInfoFormModel["ViewModel"];
	onSetViewModel: HotelSettingsHotelInfoFormModelOnSetViewModelType;
};

export type HotelSettingsHotelInfoFormModelAddressAndGeoLocationMethodsType = {
	addressMethods: {
		isEdited: boolean | undefined;
		hasError: boolean;
		address: ForAutoGenerator<InputMaybe<AddressObject> | undefined, "">;
		onSetPref: (e: string) => void;
		onSetCity: (e: string) => void;
		onSetTown: (e: string) => void;
		onSetPostalCode: (e: string) => Promise<void>;
	};
	geoLocationMethods: {
		isEdited: boolean;
		hasError: boolean;
		geoLocation:
			| ForAutoGenerator<GeoLocationInput, "">
			| ForAutoGenerator<Partial<GeoLocationInput>, "">
			| null
			| undefined;
		onSetLatitude: (number: number | undefined) => void;
		onSetLongitude: (number: number | undefined) => void;
	};
};

export const useHotelInfoAddress = ({
	viewModel,
	onSetViewModel,
}: Props): HotelSettingsHotelInfoFormModelAddressAndGeoLocationMethodsType => {
	return {
		addressMethods: {
			...useFormAddressModel({ address: viewModel.address, onSetViewModel }),
		},
		geoLocationMethods: {
			...useGeoLocation({ geoLocation: viewModel.geoLocation, onSetViewModel }),
		},
	};
};
